const env = document.location.hostname.includes('localhost')
  ? 'local'
  : process.env.REACT_APP_current_stage === 'prod'
    ? 'prod'
    : 'dev'
const GOOGLE_ANALYTICS_4_TRAKING_ID_OBJ = {
  local: 'G-1SD89TJ089',
  dev: 'G-1SD89TJ089',
  prod: 'G-FJKRRLFFFL'
}
const GOOGLE_TAG_MANGER_OBJ = {
  local: 'GTM-KRW9VM8',
  dev: 'GTM-KRW9VM8',
  prod: 'GTM-T63B5KD'
}
const DOMAIN_OBJ = {
  local: 'localhost',
  dev: 'dev-web.gemvision.com',
  prod: 'gemvision.com'
}
const BASE_URL_OBJ = {
  local: 'https://api-dev.gemvision.com',
  dev: 'https://api-dev.gemvision.com',
  prod: 'https://api.gemvision.com'
}
export class config {
  static get REGION() {
    return 'us-east-1'
  }
  static get USER_POOL_ID() {
    return 'us-east-1_XSISJT4rm'
  }
  static get APP_CLIENT_ID() {
    return '4se98otsgp0t66i614g8ahrufn'
  }
  static get DOMAIN() {
    return DOMAIN_OBJ[env]
  }
  static get GOOGLE_ANALYTICS_4_TRAKING_ID() {
    return GOOGLE_ANALYTICS_4_TRAKING_ID_OBJ[env]
  }
  static get GOOGLE_TAG_MANAGER() {
    return GOOGLE_TAG_MANGER_OBJ[env]
  }
  static get BASE_URL() {
    return BASE_URL_OBJ[env]
  }
}
